export const textValues = {
    mustVistFormError: "Select a Uid",
    mustVistFormErrorLabel: 'Add "Must visit" universities from',
    appliedLabel: "Applied",
    applyLabel: "Apply"
}